<script>
	import AddRemove from "./AddRemove.svelte";
	import Settings from "./Settings.svelte";
	import Pal from "./Pal.svelte";

	import { pals, show_settings } from "./stores";

</script>

<main>
	<div class="sider">
		<h1>Pal CRM</h1>
		<div
			on:click={() => {
				$show_settings = !$show_settings;
			}}
			style="cursor: pointer;"
		>
			<img
				src="/images/sliders.svg"
				style="float: right;"
				alt="settings button"
			/>
		</div>
	</div>

	<Settings />

	<!-- <p>feathericons.com</p> -->

	{#key $pals}
		{#each $pals as pal}
			<Pal
				name={pal.name}
				key={pal.key}
				last_contact={pal.last_contacted}
				notes={pal.notes}
			/>
		{/each}
	{/key}

	<AddRemove />
</main>

<style>
	main {
		max-width: 800px;
		font-family: sans-serif;
		font-size: 20px;
		line-height: 30px;
		padding: 2px;
	}

	h1 {
		color: red;
		font-size: 22px;
	}
</style>
